import { Component, Input, OnInit } from '@angular/core';
import { VisaService } from '@modules/payment/services/visa.service';
import { find, propEq, propOr, pipe } from 'ramda';

@Component({
    selector: 'app-payment-visa-response-error',
    providers: [VisaService],
    templateUrl: './payment-visa-response-error.component.html',
    styleUrls: ['./payment-visa-response-error.component.scss'],
})
export class PaymentVisaResponseErrorComponent implements OnInit {
    @Input() transactionId: string;
    @Input() dataResponse: Partial<NiubizAuthorizationResponse>;

    visaResponseParse: any = [];
    constructor(private _visaService: VisaService) {}

    ngOnInit() {
        this._getVisaResponseParse();
    }

    private _getVisaResponseParse() {
        this._visaService.getVisaResponseValue().subscribe(
            (response) => {
                this.visaResponseParse = response;
            },
            (error) => {
                console.error(error);
            }
        );
    }

    public visaResponseParser(code: any) {
        return pipe(
            find(propEq('code', Number(code))),
            propOr('ERROR DESCONOCIDO', 'user_msg')
        )(this.visaResponseParse);
    }
}
